export const NAMESPACE = 'wix.form_app.form';

export const TEMP_NAMESPACE = 'wix.form_app.form.temp';
